import { useEffect } from 'react';
import ReactGA from "react-ga4";

export const usePageTracking = () => {
    useEffect(() => {
      const path = window.location.pathname + window.location.search;
      
      if (window.self === window.top) {
        ReactGA.send({ hitType: "pageview", page: path });
      }
    }, []);
  };
  
